enum PlaylistTypes {
  Region = 1,
  Segment = 2
}

export default PlaylistTypes;
